import { render, staticRenderFns } from "./VendedoresIndex.vue?vue&type=template&id=631bbed3&"
import script from "./VendedoresIndex.vue?vue&type=script&lang=js&"
export * from "./VendedoresIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports